import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AppBody from "../components/AppBody";
import {
  createTakeCall,
  getTrainerList
} from "../../actions/trainer/assign_trainer_action";
import { map } from "jquery";
import DatePicker from "react-datepicker";
import { useState } from "react";

const AssignTrainerPage = () => {
  const dispatch = useDispatch("");
  const state = useSelector((state) => state.assignTrainerReducer);
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState({});
  const [trainerIds, setTrainerIds] = useState([]);
  const {slug}=useParams(); 
  const [details, setDetails] = useState({
    title: "",
    start: "",
    slug:slug,
    end:""
  });

  useEffect(() => {
    dispatch(getTrainerList({search:""}));
  }, []);

  const addTakeCallDetails = () => {
    dispatch(createTakeCall({ ...details, trainer_ids: trainerIds }));
  };

  const getTrainerId = (id) => {
    if (!trainerIds.includes(id)) {
      setTrainerIds([...trainerIds, id]);
    } else {
      setTrainerIds(trainerIds.filter((item) => item !== id));
    }
  };
 
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="">
            <div className="card">
              <div className="card-header p-3 w-100 border-0 d-flex rounded-lg">
                <h4 className="font-xs text-white fw-600 mb-0 mt-2">
                  Search Trainers
                </h4>
              </div>
              <div className="card-body p-4 w-100 border-0 ">
                <form>
                  <div className="row">
                    <div className="col-lg-4 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Start Date & Time
                        </label>
                        <DatePicker
                          className="form-control"
                          selected={details.start}
                          minDate={new Date()}
                          onChange={(date) =>
                            setDetails({ ...details, start: date })
                          }
                          showTimeSelect
                          dateFormat="Pp"
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.start : ""}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-4 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          End Date & Time
                        </label>
                        <DatePicker
                          className="form-control"
                          selected={details.end}
                          minDate={new Date()}
                          onChange={(date) =>
                            setDetails({ ...details, end: date })
                          }
                          showTimeSelect
                          dateFormat="Pp"
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.end : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-4 mb-2">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Call Title
                        </label>
                        <input
                          placeholder="Enter No Of Participants"
                          type="text"
                          className="form-control"
                          value={details.title}
                          onChange={(e) =>
                            setDetails({
                              ...details,
                              title: e.target.value
                            })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.title : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </form>

                <div className="row">
                  <div className="col-md-12 usr-course-div">
                    <input
                      type="text"
                      placeholder="Search Trainers"
                      className="form-control usr-course-search"
                    />
                    <br />
                    <br />
                  </div>
                </div>

                {trainerIds.length > 0 && (
                  <div className="row">
                    <div className="col-md-12">
                      <button
                        className="btn-common take-call-btn"
                        type="button"
                         onClick={()=>addTakeCallDetails()}
                      >
                        Add Take Call
                      </button>
                    </div>
                  </div>
                )}
                <h2 className="text-white text-center">Click on the tiles </h2>
                <div className="row cource-section">
                  {state.trainerList &&
                    state.trainerList.map((li, i) => (
                      <div
                        className="col-lg-4 mb-3"
                        onClick={() => getTrainerId(li.id)}
                      >
                        <div
                          className={
                            trainerIds.includes(li.id)
                              ? "box selected-trainer"
                              : "box"
                          }
                        >
                          <div className="row">
                            <div className="col-xs-12 col-12">
                              <h4 className="title certification-nm">
                                <span className="certification-nm text-center">
                                  <b>{li.first_name + " " + li.last_name}</b>
                                </span>
                              </h4>
                              {/*<p className="course-count">10+ Courses</p>*/}
                            </div>
                            <div className="col-xs-6 col-6">
                              <h6 className="cer-details">
                                {" "}
                                <b>{"Total Experience "}</b>
                              </h6>
                              <h6 className="cer-details">{"5 Year"}</h6>
                            </div>
                            <div className="col-xs-6 col-6">
                              <h6 className="cer-details">
                                <b>{"Rate Per Hours "}</b>
                              </h6>
                              <h6 className="cer-details">{"20 $"}</h6>
                            </div>

                            <div className="col-xs-8 col-8">
                              <h6 className="cer-details">
                                <b>Skills</b>
                              </h6>
                              <h6 className="cer-details">
                                {"React,Anular, HTML,SQL,Cloud"}
                              </h6>
                            </div>
                            <div className="col-xs-4 col-4 align-r">
                              <a
                                className="line-height-36 custom-icon mr-2"
                                title="View Profile"
                                onClick={() => setProfileData(li)}
                              >
                                <i className="fa fa-eye"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AssignTrainerPage;
